import './styles.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ComingSoonPopUp = () => {
  const { t } = useTranslation()

  return (
    <div className="coming-soon-popup-container">
      <div className="coming-soon-popup-content">
        <div className="coming-soon-image-wrapper">
          <img src="https://coffeeweb.s3.ap-south-1.amazonaws.com/coffeeweb_colored_logo.png" alt="thumbnail" />
        </div>
        <div className="coming-soon-text-wrapper">
          <h1>{t('COMING_SOON')}</h1>
        </div>
      </div>
    </div>
  )
}

export default ComingSoonPopUp
